import React, { useReducer } from "react";
import { Dialog, DialogTitle, DialogContent, DialogContentText, TextField, DialogActions, Button } from "@mui/material";

export function RejectDialog({ handleRejectClick, handleCloseClick}: {handleRejectClick: any, handleCloseClick: any}) {
  const [open, setOpen] = React.useState(true);  
  const [form, setForm] = useReducer(
    (form, updates) => ({...form, ...updates}),
    {reason: ''}
  );

  const handleChange = (fieldName: string, value: any) => {
      setForm({[fieldName]: value}); 
      console.log('update form', form);
  }

  return (
    <div>
      <Dialog open={open} onClose={handleCloseClick} PaperProps={{ style: { minWidth: "650px" } }}>
        <DialogTitle sx={{ fontWeight: "bold" }}>Rejection Reason</DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ color: "rgba(63, 66, 66, 0.767)", whiteSpace: "pre-line" }}>
            <TextField
              type="text"
              variant='outlined'
              color='secondary'
              label="Comments"
              onChange={e => handleChange('reason', e.target.value)}
              value={form?.reason || ''}
              fullWidth
              multiline
              sx={{width: 600}}
              size="medium"
              inputProps={{maxLength: 1000}}
            />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button id="secondary" variant="outlined" onClick={handleCloseClick}>Cancel</Button>
          <Button variant="contained" onClick={(e) => handleRejectClick(form?.reason || '')}>Confirm</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
